import { render, staticRenderFns } from "./GlobalConnectionTracking.vue?vue&type=template&id=2f05380c&scoped=true"
import script from "./GlobalConnectionTracking.vue?vue&type=script&lang=js"
export * from "./GlobalConnectionTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05380c",
  null
  
)

export default component.exports